<template>
  <div class="summary-bottom">

    <div class="summary" :class="setClassName(num)">
      <slot name="summary">
        <p class="smtxt">
          今回のSALES SCOPEの調査結果から成績優秀者の傾向レポートを無料で配布しています。<br>
          本記事で触れた営業全体の傾向だけでなく、様々な業界について比較した結果をご覧ください。
        </p>
      </slot>
    </div><!-- .summary -->

    <div class="smbinner">

      <div class="reportlead">
        <p class="rltxt">
          いわゆる「優秀なセールスパーソン像」は普遍的なものではありません。<br>
          商材や営業手法が異なれば、もちろん求められるセールスパーソン像も異なります。
        </p>
      </div><!-- .reportlead -->

      <div class="reportdl _block-two">
        <div class="block">
          <p class="rdtxt">
            <span class="_skblue">各種業界</span>の<span class="_skblue">優秀層傾向レポートを</span><br><span class="_skblue">無料</span>で<span class="_skblue">配信</span>しております。
          </p>
          <a href="https://sales-score.jp/download/registration/?document=salesscope" class="dlbtn" target="_blank">資料請求ダウンロード</a>
        </div>
        <div class="block">
          <a href="https://sales-score.jp/download/registration/?document=salesscope" class="sslink" target="_blank"><img src="../assets/img/cmn/ssimg.png" alt="SALES SCORE" class="ssimg"></a>
        </div>
      </div><!-- .reportdl -->          
    </div><!-- .smbinner -->
  </div><!-- .smbottom -->
</template>

<script>
export default {
  props: ["bgColor"],
  data() {
    return {
      num: this.bgColor,
    };
  },  
  computed:{
    setClassName(){
      return function(num){
        let addC;
        if(num == 2){
          addC = '-yellow'; 
        }else if(num == 4){
          addC = '-pink'; 
        }else if(num == 1){
          addC = '-green'; 
        }else{
          addC = ''; 
        }
        return addC;
      }
    }
  }
}
</script>